import { DoubleText } from "@components/ui"

type Props = {
  children: JSX.Element
  title?: string
  subtitle?: string
  inverted?: boolean
  color?: string
  id?: string
}

const Banner = ({
  children,
  title,
  subtitle,
  inverted,
  color = "text-white bg-gray-900 dark:bg-gray-100",
  id
}: Props) => {
  return (
    <>
      <div
        className={`relative psx-2 py-24 sm:py-32 text-center ${color}`}
        id={id}
      >
        {title && (
          <div className="mb-6 sm:mb-8">
            <DoubleText
              inactive
              inverted={inverted}
              logoText={title}
              size="text-4xl sm:text-5xl"
              position=""
            />
            {subtitle && (
              <p className="text-lg font-bold text-gray-200 mt-6">{subtitle}</p>
            )}
          </div>
        )}
        {children}
      </div>
    </>
  )
}

export default Banner
